__turbopack_context__.v({
  "dot": "typing-dots-module__oJwlTW__dot",
  "dots": "typing-dots-module__oJwlTW__dots",
  "dotsTextLine": "typing-dots-module__oJwlTW__dotsTextLine",
  "typingBounce": "typing-dots-module__oJwlTW__typingBounce",
});
